
jQuery("#main-banner-carousel").owlCarousel({
    autoplay: true,
    lazyLoad: true,
    loop: true,
    margin: 0,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    touchDrag  : false,
    mouseDrag  : false,
    responsiveClass: true,
    autoHeight: true,
    autoplayTimeout: 7000,
    smartSpeed: 500,
  	autoplayHoverPause:true,
    nav: true,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="21.073" height="38.635" viewBox="0 0 21.073 38.635"><path id="XMLID_222_" d="M75.515,18.075,93.076.514A1.756,1.756,0,0,1,95.559,3L79.24,19.317l16.319,16.32a1.756,1.756,0,1,1-2.484,2.483L75.515,20.558a1.756,1.756,0,0,1,0-2.483Z" transform="translate(-75 0)" fill="#fff"/></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="21.073" height="38.635" viewBox="0 0 21.073 38.635"><path id="XMLID_222_" d="M95.559,18.075,78,.514A1.756,1.756,0,0,0,75.515,3L91.834,19.317,75.515,35.636A1.756,1.756,0,1,0,78,38.12L95.559,20.558a1.756,1.756,0,0,0,0-2.483Z" transform="translate(-75 0)" fill="#fff"/></svg>',
    ],
    dots: false,
    responsive: {
      0: {
        items: 1
      },
  
      767: {
        items: 1
      },
  
      991: {
        items: 1
      },
  
      1200: {
        items: 1
      }
    }
});

jQuery(".collection-slider-carousel").owlCarousel({
  autoplay: false,
  lazyLoad: true,
  loop: true,
  margin: 15,
   /*
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  */
  responsiveClass: true,
  autoHeight: true,
  autoplayTimeout: 7000,
  smartSpeed: 300,
  nav: true,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" width="21.073" height="38.635" viewBox="0 0 21.073 38.635"><path id="XMLID_222_" d="M75.515,18.075,93.076.514A1.756,1.756,0,0,1,95.559,3L79.24,19.317l16.319,16.32a1.756,1.756,0,1,1-2.484,2.483L75.515,20.558a1.756,1.756,0,0,1,0-2.483Z" transform="translate(-75 0)" fill="#060606"/></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="21.073" height="38.635" viewBox="0 0 21.073 38.635"><path id="XMLID_222_" d="M95.559,18.075,78,.514A1.756,1.756,0,0,0,75.515,3L91.834,19.317,75.515,35.636A1.756,1.756,0,1,0,78,38.12L95.559,20.558a1.756,1.756,0,0,0,0-2.483Z" transform="translate(-75 0)" fill="#060606"/></svg>',
  ],
  dots: false,
  slideBy: 4,
  responsive: {
    0: {
      items: 2,
      margin: 10
    },

    767: {
      items: 2
    },

    991: {
      items: 4
    },

    1200: {
      items: 4
    }
  }
});

// Product Slider

$(document).ready(function($) {
    $('.product-main-images').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: false,
      infinite: false,
      accessibility: false,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
      asNavFor: '.product-thumb-images'
    });
    
    $('.product-thumb-images').slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      asNavFor: '.product-main-images',
      dots: false,
      arrows: false,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16.224" height="12.64" viewBox="0 0 16.224 12.64"><path id="Path_2" data-name="Path 2" d="M251.364,390.571h14.708l-5.383,5.378a.349.349,0,0,0,.494.494l5.966-5.972a.308.308,0,0,0,.043-.053.209.209,0,0,0,.016-.026l.017-.035.01-.035a.143.143,0,0,0,0-.029.342.342,0,0,0,0-.135.143.143,0,0,0,0-.029l-.01-.035-.017-.035a.2.2,0,0,0-.016-.026.307.307,0,0,0-.043-.054l-5.966-5.972A.345.345,0,0,0,260.7,384l-.006.005a.345.345,0,0,0,0,.489h0l5.383,5.383H251.364a.345.345,0,1,0,0,.691Z" transform="translate(267.243 396.545) rotate(180)" fill="#030504"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16.224" height="12.64" viewBox="0 0 16.224 12.64"><path id="Path_2" data-name="Path 2" d="M251.364,390.571h14.708l-5.383,5.378a.349.349,0,0,0,.494.494l5.966-5.972a.308.308,0,0,0,.043-.053.209.209,0,0,0,.016-.026l.017-.035.01-.035a.143.143,0,0,0,0-.029.342.342,0,0,0,0-.135.143.143,0,0,0,0-.029l-.01-.035-.017-.035a.2.2,0,0,0-.016-.026.307.307,0,0,0-.043-.054l-5.966-5.972A.345.345,0,0,0,260.7,384l-.006.005a.345.345,0,0,0,0,.489h0l5.383,5.383H251.364a.345.345,0,1,0,0,.691Z" transform="translate(-251.019 -383.905)" fill="#030504"/></svg></button>',
      infinite: false,
      vertical: false,
      autoplay: false,
      centerPadding: "0px",
      adaptiveHeight: true,
      centerMode: false,
      focusOnSelect: true
    });
});

// Product Slider Zoom

$(document).ready(function(){
  if ($(window).width() > 991) {
    $('.image-zoom')
    .wrap('<span style="display:inline-block"></span>')
    .css('display', 'block')
    .parent()
    .zoom({
      url: $(this).find('img').attr('data-zoom')
    });
  }
});

// PhotoSwipe

(function($) {

  // Init empty gallery array
  let galleryArray = [];

  // Loop over gallery items and push it to the array
  $('.gallery').find('figure').each(function() {
    var $link = $(this).find('a'),
      item = {
        src: $link.attr('href'),
        w: $link.data('width'),
        h: $link.data('height'),
        title: $link.attr('title') 
      };
    galleryArray.push(item);
  });
	
	console.log(galleryArray);
  
  // Define click event on gallery item
  $('.open-galley').click(function(event) {

    // Prevent location change
    event.preventDefault();

    // Define object and gallery options
    var $pswp = $('.pswp')[0],
      options = {
        index: $(this).parent('figure').index(),
        bgOpacity: 0.85,
        showHideOpacity: true
      };
    
    // Initialize PhotoSwipe
    var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, galleryArray, options);
    gallery.init();
  });

}(jQuery));


// Product Detail Page Accordioan

document.addEventListener("DOMContentLoaded", function() {
  var accordionItems = document.querySelectorAll(".accordion-item");

  accordionItems.forEach(function(item) {
    item.querySelector(".accordion-header").addEventListener("click", function() {
      // Close all other accordion items
      accordionItems.forEach(function(otherItem) {
        if (otherItem !== item) {
          otherItem.querySelector(".accordion-body").style.display = "none";
          otherItem.querySelector(".accordion-toggle").textContent = "+";
        }
      });

      // Toggle the clicked item
      var body = item.querySelector(".accordion-body");
      if (body.style.display === "block") {
        body.style.display = "none";
        item.querySelector(".accordion-toggle").textContent = "+";
      } else {
        body.style.display = "block";
        item.querySelector(".accordion-toggle").textContent = "-";
      }
    });
  });
});